import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, LabelList, Cell } from 'recharts';

import Tick from 'components/charts/Tick';
import TooltipContent from 'components/charts/Tooltip';

const STACK_ID = 'BusinessStatusStackId';

const Graph = ({ data, syncId = null, tooltipFormatter, labelFormatter }) => (
    <ResponsiveContainer maxHeight={150} width="99%" aspect={3}>
        <BarChart syncId={syncId} data={data} layout="vertical" margin={{ right: 75 }}>
            <Bar
                key="guaranteed"
                name="guaranteed"
                barSize={30}
                dataKey="guaranteedBar.value"
                isAnimationActive={false}
                stackId={STACK_ID}
            >
                {data.map((row) => (
                    <Cell key={`guaranteed-${row.title}`} fill={row.guaranteedBar.colour} />
                ))}
            </Bar>
            <Bar
                key="nonGuaranteed"
                name="nonGuaranteed"
                barSize={30}
                dataKey="nonGuaranteedBar.value"
                isAnimationActive={false}
                stackId={STACK_ID}
            >
                {data.map(
                    (row) =>
                        row.nonGuaranteedBar && (
                            <Cell key={`nonGuaranteed-${row.title}`} fill={row.nonGuaranteedBar.colour} />
                        ),
                )}
                <LabelList position="right" formatter={labelFormatter} fill="#555" />
            </Bar>

            <XAxis type="number" hide domain={[0, 'dataMax']} />
            <YAxis
                dataKey="title"
                type="category"
                interval={0} // show all ticks
                width={70} // enough space for EN labels
                tickLine={false}
                tick={<Tick fontSize={12} />}
            />

            <Tooltip
                cursor={false}
                content={<TooltipContent formatter={tooltipFormatter} />}
                isAnimationActive={false}
            />
        </BarChart>
    </ResponsiveContainer>
);

export default Graph;
